<svg viewBox="0 0 24 24" {...$$restProps} xmlns="http://www.w3.org/2000/svg">
  <path d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M19,18 L5,18 C4.45,18 4,17.55 4,17 L4,8 L10.94,12.34 C11.59,12.75 12.41,12.75 13.06,12.34 L20,8 L20,17 C20,17.55 19.55,18 19,18 Z M12,11 L4,6 L20,6 L12,11 Z"/>
</svg>
